import { render, staticRenderFns } from "./PrintInvoice.vue?vue&type=template&id=4b6acc4a&scoped=true&"
import script from "./PrintInvoice.vue?vue&type=script&lang=js&"
export * from "./PrintInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PrintInvoice.vue?vue&type=style&index=0&id=4b6acc4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6acc4a",
  null
  
)

export default component.exports